import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Hero from '../components/Hero';
import { Vazio } from '../components/Documentos';
import useTitulo from '../utils/useTitulo';

function NaoEncontrado() {
    useTitulo('Página não encontrada');
    return (
        <>
            <Hero titulo="Página não encontrada" />
            <div className="hub-corpo">
                <Container>
                    <Vazio>
                        O endereço acessado não existe. <Link to="/">Voltar ao início</Link>
                    </Vazio>
                </Container>
            </div>
        </>
    );
}

export default NaoEncontrado;
